<div class="overlay" (click)="_onOverlayClicked($event)">
  <div (click)="_onPopupClicked($event)" class="popup">
    <ng-template appInsertion></ng-template>
  </div>
</div>
